import {
  format,
  setYear,
  setMonth,
  setDate,
  setHours,
  setMinutes,
  isEqual,
  isAfter
} from 'date-fns'
import { convertToTimeZone } from 'date-fns-timezone'
import _ from 'lodash'

export default {
  splitHour: () => (time) => {
    if (time) {
      return time.split(':')[0]
    }
  },

  splitMinute: () => (time) => {
    if (time) {
      return time.split(':')[1]
    }
  },

  minYear: () => {
    return format(new Date(), 'Y')
  },

  dateFormat: (state) => {
    let date = new Date()
    date = setYear(date, state.year)
    date = setMonth(date, state.month - 1)
    date = setDate(date, state.day)
    return date
  },

  startFormat: (state) => {
    return state.startHour + ':' + _.padStart(state.startMinute, 2, '0')
  },

  finishFormat: (state) => {
    return state.finishHour + ':' + _.padStart(state.finishMinute, 2, '0')
  },

  start: (state, getters) => (event) => {
    let start = new Date()
    let startHour
    let startMinute

    if (event) {
      start = event.get('date')
      startHour = getters.splitHour(event.get('start'))
      startMinute = getters.splitMinute(event.get('start'))
    } else {
      startHour = state.startHour
      startMinute = state.startMinute
    }
    start = setHours(start, startHour)
    return setMinutes(start, startMinute)
  },

  finish: (state, getters) => (event) => {
    let finish = new Date()
    let finishHour
    let finishMinute

    if (event) {
      finish = event.get('date')
      finishHour = getters.splitHour(event.get('finish'))
      finishMinute = getters.splitMinute(event.get('finish'))
    } else {
      finishHour = state.finishHour
      finishMinute = state.finishMinute
    }
    finish = setHours(finish, finishHour)
    return setMinutes(finish, finishMinute)
  },

  isInvalidStart: (state, getters) => {
    const start = getters.start()
    const finish = getters.finish()
    return isEqual(start, finish) || isAfter(start, finish)
  },

  hasFinished: (state, getters) => (event) => {
    let timezone = event.get('timezone')
    if (!timezone) {
      timezone = 'Asia/Tokyo'
    }
    let date = convertToTimeZone(new Date(), { timeZone: timezone })
    return isAfter(date, getters.finish(event))
  }
}
